import { render, staticRenderFns } from "./CorporateSettingsTab.vue?vue&type=template&id=03fe9921&scoped=true"
import script from "./CorporateSettingsTab.vue?vue&type=script&lang=js"
export * from "./CorporateSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./CorporateSettingsTab.vue?vue&type=style&index=0&id=03fe9921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fe9921",
  null
  
)

export default component.exports